import Vue from "vue";

import CouponsList from "./CouponsList.vue";

export function load() {
    const selector = "coupons-list";

  // Is the custom Vue root element in the DOM?
  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(CouponsList, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}